import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { WebcamImage, WebcamUtil } from 'ngx-webcam';
import { Subject, Observable } from 'rxjs';
import { ScreenType } from 'src/app/enums/ScreenType';
import { UserRegDetails } from 'src/app/models/user';
import { environment } from 'src/app/environments/environments';
@Component({
  selector: 'app-user-self-attendnace-dialog',
  templateUrl: './user-self-attendnace-dialog.component.html',
  styleUrl: './user-self-attendnace-dialog.component.scss',
})
export class UserSelfAttendnaceDialogComponent implements OnInit {
  @Output() onSubmitAttendance = new EventEmitter();
  screenSize: ScreenType;
  ScreenType = ScreenType;
  showWebcam = false;
  isDeviceSelected = false;
  deviceSelected = '';
  sysImage: string = null;
  userData: UserRegDetails;
  availableDevices: any = [];
  private trigger: Subject<any> = new Subject();
  public webcamImage!: WebcamImage;
  private nextWebcam: Subject<any> = new Subject();
  public nextWebcamObservable: Observable<boolean> =
    this.nextWebcam.asObservable();
  currentLocation: GeolocationCoordinates;
  currentUserProfile = localStorage.getItem('ProfilePic');
  baseServerURL = environment.apiUrl;
  status: 'initial' | 'requesting' | 'success' | 'error' | 'denied' = 'initial';
  errorMessage: string = '';
  cameraStatus: 'initial' | 'requesting' | 'success' | 'error' | 'denied' =
    'initial';
  cameraErrorMessage: string = '';
  selectedDeviceId: string = '';

  videoOptions: MediaTrackConstraints = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<UserSelfAttendnaceDialogComponent>,
    private http: HttpClient,
    private toastr: ToastrService
  ) {
    this.screenSize = data.screen;
    this.userData = data.userData;
    if (!navigator.mediaDevices?.enumerateDevices) {
      console.log('enumerateDevices() not supported.');
    } else {
      (async () => {
        try {
          // Get list of available devices

          this.availableDevices = await WebcamUtil.getAvailableVideoInputs();

          // Select the first device by default if available

          if (this.availableDevices.length > 0) {
            // this.selectedDeviceId = this.availableDevices[0].deviceId;
            // this.updateVideoOptions();
          }
        } catch (error) {
          console.error('Error initializing webcam:', error);
        }
      })(); // <-- Invoking the async function here
    }
  }
  async initializeCamera() {
    if (!navigator.mediaDevices?.getUserMedia) {
      this.cameraStatus = 'error';
      this.cameraErrorMessage =
        'Camera access is not supported by this browser';
      return;
    }

    this.cameraStatus = 'requesting';

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      // If we get here, permission was granted
      stream.getTracks().forEach((track) => track.stop()); // Stop the stream as we'll handle it via webcam component

      // Get available devices
      this.availableDevices = await WebcamUtil.getAvailableVideoInputs();

      if (this.availableDevices.length === 0) {
        this.cameraStatus = 'error';
        this.cameraErrorMessage = 'No camera devices found';
        return;
      }

      this.cameraStatus = 'success';
      // this.selectedDeviceId = this.availableDevices[0].deviceId;
      // this.updateVideoOptions();
    } catch (error) {
      console.error('Camera access error:', error);

      if (error instanceof DOMException) {
        switch (error.name) {
          case 'NotAllowedError':
          case 'PermissionDeniedError':
            this.cameraStatus = 'denied';
            break;
          case 'NotFoundError':
          case 'DevicesNotFoundError':
            this.cameraStatus = 'error';
            this.cameraErrorMessage = 'No camera devices found';
            break;
          case 'NotReadableError':
          case 'TrackStartError':
            this.cameraStatus = 'error';
            this.cameraErrorMessage = 'Camera is in use by another application';
            break;
          default:
            this.cameraStatus = 'error';
            this.cameraErrorMessage =
              'An unknown error occurred while accessing the camera';
        }
      } else {
        this.cameraStatus = 'error';
        this.cameraErrorMessage = 'Failed to access camera';
      }
    }
  }
  ngOnInit(): void {
    // Check if geolocation is supported first
    if (!('geolocation' in navigator)) {
      this.status = 'error';
      this.errorMessage = 'Geolocation is not supported by this browser';
      return;
    }
    // Automatically request location after a short delay
    setTimeout(() => {
      this.getCurrentLocation();
    }, 500);
    // Initialize camera
    setTimeout(() => {
      this.initializeCamera();
    }, 1000);
  }
  getSnapshot(): void {
    this.trigger.next(void 0);
    this.showWebcam = !this.showWebcam;
  }

  get invokeObservable(): Observable<any> {
    return this.trigger.asObservable();
  }
  toggleWebcam() {
    if (this.showWebcam) {
      this.trigger.next(void 0);
    } else {
      this.sysImage = '';

      this.showWebcam = true;
    }
  }
  public showNextWebcam(directionOrDeviceId: boolean | string): void {
    this.nextWebcam.next(directionOrDeviceId);
    // this.showWebcam = true;
  }
  onDeviceSelectChange(val: any) {
    this.isDeviceSelected = true;
    this.showNextWebcam(val);

    this.selectedDeviceId = val;
    this.updateVideoOptions();
  }
  captureImg(webcamImage: WebcamImage): void {
    this.webcamImage = webcamImage;
    this.sysImage = webcamImage!.imageAsDataUrl;
  }
  onClickSubmit() {
    this.isClickedSubmit = true;
    this.VerifyFaceEmployee(this.sysImage, this.currentUserProfile);
  }
  isFaceMatched = false;
  isApiFetching = false;
  isError = false;
  isLocationError = false;
  isClickedSubmit = false;
  VerifyFaceEmployee(detectedImage: string, qrScannedImageLink: string) {
    this.isApiFetching = true;
    let baseServerURL = this.baseServerURL + 'EmployeeFaceMatch';
    const faceForm = {
      detectedImageBase64: detectedImage,
      qrScannedImage: qrScannedImageLink,
      isSelf: true,
      isVisitor: false,
      userLocation: this.userData.userLocation,
      currentLocation: {
        latitude: this.currentLocation.latitude,
        longitude: this.currentLocation.longitude,
        altitude: this.currentLocation.altitude, // Might be null
        altitudeAccuracy: this.currentLocation.altitudeAccuracy, // Might be null
        heading: this.currentLocation.heading, // Might be null unless moving
        speed: this.currentLocation.speed, // Might be null if not moving
        accuracy: this.currentLocation.accuracy, // Accuracy of latitude/longitude
      },
      employeeId: this.userData.userId,
    };

    this.http
      .post(baseServerURL, faceForm, {
        responseType: 'text',
      })
      .subscribe(
        (res: any) => {
          const parts = res.split('#');

          this.isApiFetching = false;
          this.isFaceMatched = true;
          this.toastr.success('Face Matched');
          if (parts[1] && parts[1].length > 1) {
            this.toastr.warning(parts[1], 'Spoof Detected', {
              closeButton: true,

              timeOut: 4000,

              progressBar: true,

              enableHtml: true,

              tapToDismiss: true,
            });
          }
          this.onAddEmployeeAttendance();
        },
        (err) => {
          const parts = err.error.split('#');
          this.isApiFetching = false;
          this.isError = true;
          if (err.error == 'Out of location') {
            this.isLocationError = true;
            this.toastr.error(err.error);
          } else if (parts[0] == 'Face Not Matched') {
            this.isLocationError = false;
            this.toastr.error('Face Not Matched');
            if (parts[1] && parts[1].length > 1) {
              this.toastr.warning(parts[1], 'Spoof Detected', {
                closeButton: true,

                timeOut: 4000,

                progressBar: true,

                enableHtml: true,

                tapToDismiss: true,
              });
            }
          } else {
            this.isAnotherErr = true;
            this.toastr.error(err.error);
          }
          setTimeout(() => {
            this.dialogRef.close();
          }, 3000);
        }
      );
  }
  isAnotherErr = false;
  onAddEmployeeAttendance() {
    this.onSubmitAttendance.emit();
  }

  /* Handle no location found */
  noLocationFound(errorMsg: string) {
    /* Write code here to handle: user location is unavailable */
    console.log(errorMsg);
    window.alert(errorMsg);
  }

  getCurrentLocation() {
    if (!('geolocation' in navigator)) {
      this.status = 'error';
      this.errorMessage = 'Geolocation is not supported by this browser';
      return;
    }

    this.status = 'requesting';
    navigator.geolocation.getCurrentPosition(
      (position) => {
        this.currentLocation = position.coords;
      },
      (error) => {
        // window.alert(error);
      }
    );
    navigator.geolocation.getCurrentPosition(
      (position) => {
        // Success handler
        this.currentLocation = position.coords;
        this.status = 'success';
      },
      (error) => {
        // Error handler
        switch (error.code) {
          case error.PERMISSION_DENIED:
            this.status = 'denied';
            this.errorMessage = 'Location permission was denied';
            break;
          case error.POSITION_UNAVAILABLE:
            this.status = 'error';
            this.errorMessage = 'Location information is unavailable';
            break;
          case error.TIMEOUT:
            this.status = 'error';
            this.errorMessage = 'Location request timed out';
            break;
          default:
            this.status = 'error';
            this.errorMessage = 'An unknown error occurred';
            break;
        }
      },
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      }
    );
  }
  private updateVideoOptions() {
    if (this.cameraStatus === 'success') {
      this.showWebcam = true;
      this.videoOptions = {
        deviceId: this.selectedDeviceId,
        facingMode: 'user',
      };
    }
  }
}
